import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import ProjectRelatedBaseData from "./ProjectRelatedBaseData";

var _2013 =
/*#__PURE__*/
function (_ProjectRelatedBaseDa) {
  _inherits(_2013, _ProjectRelatedBaseDa);

  function _2013() {
    _classCallCheck(this, _2013);

    return _possibleConstructorReturn(this, _getPrototypeOf(_2013).call(this, "_2013"));
  }

  _createClass(_2013, [{
    key: "Create",
    value: function () {
      var _Create = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(propertyId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.post("/api/".concat(this._controller, "/").concat(propertyId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function Create(_x) {
        return _Create.apply(this, arguments);
      }

      return Create;
    }()
  }, {
    key: "GetList",
    value: function () {
      var _GetList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(year) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetList/").concat(year)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetList(_x2) {
        return _GetList.apply(this, arguments);
      }

      return GetList;
    }()
  }, {
    key: "GetCandidates",
    value: function () {
      var _GetCandidates = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(year) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetCandidates/").concat(year)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetCandidates(_x3) {
        return _GetCandidates.apply(this, arguments);
      }

      return GetCandidates;
    }()
  }, {
    key: "Import",
    value: function () {
      var _Import = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(selectedImports, isFirm) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.post("/api/".concat(this._controller, "/Import/").concat(isFirm), selectedImports));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function Import(_x4, _x5) {
        return _Import.apply(this, arguments);
      }

      return Import;
    }()
  }, {
    key: "GetZipCityCountyPairs",
    value: function () {
      var _GetZipCityCountyPairs = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/GetZipCityCountyPairs")));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetZipCityCountyPairs() {
        return _GetZipCityCountyPairs.apply(this, arguments);
      }

      return GetZipCityCountyPairs;
    }()
  }]);

  return _2013;
}(ProjectRelatedBaseData);

export default new _2013();